// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyClipboardChip_container___pIcO"};